import React from "react";
import T from "prop-types";

import Widget from "2g-widget";
import { PeriodDay } from "2g-period";

import { useToLocaleDateFull } from "b2b/i18n";
import { RezervaceTabs } from "b2b/components/rezervace-tabs/RezervaceTabs";
import useMessages from "./i18n/useMessages";
import useRezervaceWidgetNejblizsi from "./useRezervaceWidgetNejblizsi";

export function RezervaceWidgetNejblizsi({ title }) {
  const messages = useMessages();

  const formatter = useToLocaleDateFull();

  const { headerActions, onPeriodChange, ...tabsProps } =
    useRezervaceWidgetNejblizsi();

  return (
    <Widget
      title={title || messages.titleNejblizsi()}
      collapsable={false}
      className="b2b-RezervaceWidgetNejblizsi"
      headerActions={headerActions}
    >
      <PeriodDay
        from={tabsProps.datumOd}
        to={tabsProps.datumDo}
        formatter={formatter}
        onChange={onPeriodChange}
      />

      <RezervaceTabs {...tabsProps} />
    </Widget>
  );
}

RezervaceWidgetNejblizsi.propTypes = { title: T.any };

export default React.memo(RezervaceWidgetNejblizsi);
